import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import useResize from "src/hooks/useResize";
import homeConfig from "src/resources/homePage.json";
import { isArabic } from "src/utils/helpers";

const AboutUs = () => {
  const aboutUsData = homeConfig.aboutUs;
  const { t } = useTranslation(["homePage", "common"]);
  const { isMobile } = useResize();
  const [showMore, setShowMore] = useState(false);
  return (
    <section
      className="home-section about-us d-flex flex-column flex-md-row"
      id="about-us"
    >
      <Trans>
        {!isMobile && (
          <img
            src={`${require(`src/assets/images/${aboutUsData.image.name}`)}`}
            alt={homeConfig.aboutUs.image.alt}
          />
        )}
        <div className="container">
          <h2>{t(`homePage.aboutUs.title`)}</h2>
          <span className="sub-title">{t(`homePage.aboutUs.subTitle`)}</span>
          <div className="w-100">
          {isArabic() && (showMore || !isMobile) && (
              <>
                <p>{t("homePage.aboutUs.ourMissionContent")}</p>
                <h6 className="mt-2">{t("homePage.aboutUs.ourMissionTitle")}</h6>
              </>
            )}
            <p>
              {t(`homePage.aboutUs.content`)}
              {(showMore || !isMobile) && (
                <span> {t(`homePage.aboutUs.subContent`)}</span>
              )}
            </p>
           
            {(showMore || !isMobile) && <p>{t(`homePage.aboutUs.note`)}</p>}
          </div>
          {isMobile && (
            <div
              className="show-more-text"
              onClick={() => setShowMore(!showMore)}
            >
              <span>{showMore ? "-" : "+"}</span>
              <span>{showMore ? t("less") : t("more")}</span>
            </div>
          )}
        </div>
      </Trans>
    </section>
  );
};

export default AboutUs;
